/**
 * Web mock for @react-native-ml-kit/text-recognition.
 * Same reasoning as react-native-image-picker.js — this package is native-only
 * (Metro-targeted TypeScript source webpack can't parse), and
 * ScanBusinessCardScreen already blocks the real scan-and-OCR flow on web
 * before this would ever be called.
 */

const TextRecognition = {
  recognize: () => Promise.resolve({ text: '', blocks: [] }),
};

module.exports = { default: TextRecognition };
